import { LazyModule, LazyAction, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() => import('./lazyIndex'));

// Lazy actions
export let lazyLoadSavedCalendarViews = new LazyAction(lazyModule, m => m.loadSavedCalendarViews);
export let lazyAddSavedCalendarView = new LazyAction(lazyModule, m => m.addSavedCalendarView);
export let lazyEditSavedCalendarView = new LazyAction(lazyModule, m => m.editSavedCalendarView);
export let lazyUpdateCurrentlyDisplayedViewId = new LazyAction(
    lazyModule,
    m => m.updateCurrentlyDisplayedViewId
);
export let lazyDeleteSavedCalendarView = new LazyAction(lazyModule, m => m.deleteSavedCalendarView);

// Lazy selectors
export let lazyGetSavedCalendarView = new LazyImport(lazyModule, m => m.getSavedCalendarView);
export let lazyGetSavedCalendarViewsMap = new LazyImport(
    lazyModule,
    m => m.getSavedCalendarViewsMap
);
export let lazyGetCurrentlyDisplayedViewId = new LazyImport(
    lazyModule,
    m => m.getCurrentlyDisplayedViewId
);
export let lazyHasCurrentlyDisplayedView = new LazyImport(
    lazyModule,
    m => m.hasCurrentlyDisplayedView
);

export let lazyGetUpdatedSavedViewIds = new LazyImport(lazyModule, m => m.getUpdatedSavedViewIds);

// Lazy utils
export let lazyRemoveInactiveCalendarIds = new LazyImport(
    lazyModule,
    m => m.removeInactiveCalendarIds
);

// Non-lazy interface exports

export type {
    SaveCalendarViewConfig,
    DraftSaveCalendarViewConfig,
} from './store/schema/SaveCalendarViewConfig';

// Non-lazy constants exports
export { MAX_SAVED_CALENDAR_VIEWS } from './utils/constants';
